import { render, staticRenderFns } from "./Logout.vue?vue&type=template&id=6345cc04"
import script from "./Logout.vue?vue&type=script&lang=ts"
export * from "./Logout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports